<template>
  <div class="di main-wrap">
    <!-- 这里设置了ref属性后，在vue组件中，就可以用this.$refs.audio来访问该dom元素 -->
    <audio
      ref="audio"
      class="dn"
      :src="url"
      :preload="audio.preload"
      @play="onPlay"
      @error="onError"
      @waiting="onWaiting"
      @pause="onPause"
      @timeupdate="onTimeupdate"
      @loadedmetadata="onLoadedmetadata"
    ></audio>
    <div>
      <div class="control-wrap">
        <img :src="AudiIcon" />
        <el-button
          v-if="false"
          v-show="!controlList.noSpeed"
          type="text"
          @click="changeSpeed"
          >{{ audio.speed | transSpeed }}</el-button
        >
        <el-tag type="info" v-if="false">
          {{ audio.currentTime | formatSecond }}
        </el-tag>
        <!-- @click="startPlayOrPause-->
        <el-button type="text" v-if="false">
          {{ audio.playing | transPlayPause }}
        </el-button>
        <el-slider
          v-if="false"
          v-show="!controlList.noProcess"
          v-model="sliderTime"
          :format-tooltip="formatProcessToolTip"
          @change="changeCurrentTime"
          class="slider"
        ></el-slider>
        <el-tag type="info" v-if="false">
          {{ audio.maxTime | formatSecond }}
        </el-tag>
      </div>
    </div>
  </div>
</template>

<script>
function realFormatSecond(second) {
  var secondType = typeof second
  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)
    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60
    return (
      hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    )
  } else {
    return '0:00:00'
  }
}
export default {
  props: {
    theSpeeds: {
      type: Array,
      default() {
        return [1, 1.5, 2]
      },
    },
    audioItem: {
      type: Object,
      default() {
        return {}
      },
    },
    theControlList: {
      type: String,
      default: '',
    },
  },
  watch: {
    audioItem: {
      handler(val) {
        let that = this
        let match_host = 'http://10.1.137.189:8062/'
        let obj = { ...val }
        if (obj && obj.url) {
          that.url = obj.url.replace(match_host, '/service_data/')
          that.dealAudiofun(obj)
        } else {
          that.url = ''
        }
        // console.log('this.audioUrl', this.url)
      },
      immediate: true,
      deep: true,
    },
  },
  name: 'VueAudio',
  data() {
    return {
      url: '',
      audio: {
        currentTime: 0,
        maxTime: 0,
        playing: false,
        muted: false,
        speed: 1,
        waiting: true,
        preload: 'auto',
      },
      AudiIcon: require('../../../public/images/icon-audio.png'),
      sliderTime: 0,
      volume: 100,
      speeds: this.theSpeeds,
      controlList: {
        // 不显示下载
        noDownload: false,
        // 不显示静音
        noMuted: false,
        // 不显示音量条
        noVolume: false,
        // 不显示进度条
        noProcess: false,
        // 只能播放一个
        onlyOnePlaying: false,
        // 不要快进按钮
        noSpeed: false,
      },
    }
  },
  methods: {
    //处理播放功能
    dealAudiofun(audio) {
      setTimeout(() => {
        if (audio.attribute == 'play') {
          this.onLoad()
          this.startPlay()
        } else if (audio.attribute == 'pause') this.pausePlay()
        // 设置音量
        this.$refs.audio.volume = eval(audio.volume)
      }, 50)
    },

    setControlList() {
      let controlList = this.theControlList.split(' ')
      controlList.forEach((item) => {
        if (this.controlList[item] !== undefined) {
          this.controlList[item] = true
        }
      })
    },
    changeSpeed() {
      let index = this.speeds.indexOf(this.audio.speed) + 1
      this.audio.speed = this.speeds[index % this.speeds.length]
      this.$refs.audio.playbackRate = this.audio.speed
    },
    startMutedOrNot() {
      this.$refs.audio.muted = !this.$refs.audio.muted
      this.audio.muted = this.$refs.audio.muted
    },
    // 音量条toolTip
    // formatVolumeToolTip(index) {
    //   return "音量条: " + index;
    // },
    // 进度条toolTip
    // formatProcessToolTip(index = 0) {
    //   index = parseInt((this.audio.maxTime / 100) * index);
    //   return "进度条: " + realFormatSecond(index);
    // },
    // 音量改变
    changeVolume(index = 0) {
      this.$refs.audio.volume = index / 100
      this.volume = index
    },
    // 播放跳转
    changeCurrentTime(index) {
      this.$refs.audio.currentTime = parseInt(
        (index / 100) * this.audio.maxTime
      )
    },
    startPlayOrPause() {
      return this.audio.playing ? this.pausePlay() : this.startPlay()
    },
    // 开始播放
    startPlay() {
      this.$refs.audio.play()
      // debugger;
    },
    // 暂停
    pausePlay() {
      this.$refs.audio.pause()
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false
    },
    // 重置音频
    onLoad() {
      this.$refs.audio.load()
    },
    // 当发生错误, 就出现loading状态
    onError() {
      this.audio.waiting = true
    },
    // 当音频开始等待
    onWaiting(res) {
      // console.log(res);
    },
    // 当音频开始播放
    onPlay(res) {
      this.audio.playing = true
      this.audio.loading = false
      if (!this.controlList.onlyOnePlaying) {
        return
      }
      let target = res.target
      let audios = document.getElementsByTagName('audio')
      ;[...audios].forEach((item) => {
        if (item !== target) {
          item.pause()
        }
      })
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      // console.log('timeupdate')
      // console.log(res)
      this.audio.currentTime = res.target.currentTime
      this.sliderTime = parseInt(
        (this.audio.currentTime / this.audio.maxTime) * 100
      )
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
      this.audio.waiting = false
      this.audio.maxTime = parseInt(res.target.duration)
    },
  },
  filters: {
    formatSecond(second = 0) {
      return realFormatSecond(second)
    },
    transPlayPause(value) {
      return value ? '暂停' : '播放'
    },
    transMutedOrNot(value) {
      return value ? '放音' : '静音'
    },
    transSpeed(value) {
      return '快进: x' + value
    },
  },
  created() {
    this.setControlList()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin flex-between {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main-wrap {
  // width: 100%;
  position: absolute;
  z-index: 5;
  margin-top: 40px;
  right: 20px;

  .control-wrap {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    // background-image: linear-gradient(to right, #618aff, #8c6bf9);
    // height: 80px;
    // line-height: 80px;
    // margin-top: 35px;

    ::v-deep .el-button--text {
      width: 15%;
      text-align: center;
      color: #fff;
      padding-left: 10px;
    }
    .slider {
      display: inline-block;
      min-width: 120px;
      width: 90%;
      position: relative;
      top: 0px;
      margin-left: 15px;
      padding: 10px 15px;
    }

    ::v-deep .el-tag.el-tag--info {
      background-color: transparent;
      border: 0px solid #fff;
      color: #fff;
      position: absolute;
      margin-top: 20px;
      margin-left: 60%;
    }
  }
}

.di {
  display: inline-block;
}
.download {
  color: #fff;
  // color: #4c88ff;
  margin-left: 15px;
}
.dn {
  display: none;
}
.play-pause-btn {
  display: none;
  cursor: pointer;
}
</style>
